import { useQuery } from '@tanstack/react-query'
import { useAuth } from './useAuth'
import { throwOnError } from '../utils/throwOnError'
import type { components } from '../types/prove-v1'

export type SampleTakingPlannedEndpoint =
  components['schemas']['SampleTakingPlannedEndpoint']

export type SampleTakingReportQueryParams = {
  from: string
  through: string
  planId?: number
  ownerType?: 'region' | 'avdeling' | 'seksjon' | 'team'
  ownerId?: string
  ownerScope?: 'exact' | 'subtree'
  eftaCode?: string
  ownerBreakdownLevel?: 'avdeling' | 'seksjon' | 'team'
}

export const useGetSampleTakingReportQuery = (
  params: SampleTakingReportQueryParams
) => {
  const { authFetch } = useAuth()
  return useQuery({
    queryKey: ['sample-taking-report', params],
    queryFn: async () => {
      const { data, error } = await authFetch().GET('/reports/sample-taking', {
        params: {
          query: {
            from: params.from,
            through: params.through,
            planId: params.planId,
            ownerType: params.ownerType,
            ownerId: params.ownerId,
            ownerScope: params.ownerScope ?? 'subtree',
            eftaCode: params.eftaCode,
            ownerBreakdownLevel: params.ownerBreakdownLevel
          }
        }
      })
      if (error) throwOnError(error)
      return data
    }
  })
}
